import config from '../config/constantconfig'

let OSS = require('ali-oss')
let client = new OSS({
  region: config.region,
  accessKeyId: config.accessKeyId,
  accessKeySecret: config.accessKeySecret,
  bucket: config.bucket
})

async function put (objName, localfile) {
  try {
    let result = await client.put(objName, localfile)
    return result
  } catch (e) {
  }
}

function asyncput (objName, localfile) {
  return client.put(objName, localfile)
}

// 分片上传
async function multipartUpload (objName, localfile, fun) {
  try {
    let result = await client.multipartUpload(objName, localfile, {
      progress: fun
    })
    let resultinfo = {
      size: result.res.size,
      rt: result.res.rt,
      url: result.name
    }
    return resultinfo
  } catch (e) {
    // 捕获超时异常
    if (e.code === 'ConnectionTimeoutError') {
      // do ConnectionTimeoutError operation
    }
  }
}

export default {
  put,
  asyncput,
  multipartUpload
}

class Uploader extends OSS {
  constructor (fileType, fileName, file) {
    let ossTypeConfig
    switch (fileType) {
      case 'image':
        ossTypeConfig = config.imageOssInfo
        break
      case 'video':
        ossTypeConfig = config.videoOssInfo
        break
      case 'audio':
        ossTypeConfig = config.audioOssInfo
        break
      default:
        ossTypeConfig = config.fileOssInfo
        break
    }
    let ossConfig = {
      region: ossTypeConfig.region,
      accessKeyId: ossTypeConfig.accessKeyId,
      accessKeySecret: ossTypeConfig.accessKeySecret,
      bucket: ossTypeConfig.bucket
    }
    super(ossConfig)
    this.ossTypeConfig = ossTypeConfig
    this.fileName = fileName
    this.file = file
  }

  async multipartUpload (checkpoint, callback) {
    try {
      let uploadConfig = {
        progress: callback
      }
      if (checkpoint) uploadConfig.checkpoint = checkpoint
      let result = await super.multipartUpload(this.fileName, this.file, uploadConfig)
      let resultinfo = {
        size: result.res.size,
        rt: result.res.rt,
        url: 'https://' + this.ossTypeConfig.url + '/' + result.name
      }
      return resultinfo
    } catch (err) {
      return err
    }
  }
}

export const getUploderObj = (fileType, fileName, file) => {
  return new Uploader(fileType, fileName, file)
}
